/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export default {
  init() {
    $(window).load(() => {
      // Related posts
      new Swiper('.related-posts-swiper .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.related-posts-swiper .swiper-pagination',
          clickable: true
        },
        breakpoints: {
          690: {
            slidesPerView: 2,
            spaceBetween: 45
          }
        }
      });

      // Related courses
      new Swiper('.related-courses-swiper .swiper-container', {
        slidesPerView: 1.3,
        spaceBetween: 19,
        pagination: {
          el: '.related-courses-swiper .swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1450: {
            slidesPerView: 4
          },
          970: {
            slidesPerView: 3.4
          },
          630: {
            slidesPerView: 2,
            spaceBetween: 23,
          },
          0: {
            spaceBetween: 18,
          }
        }
      });
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js